module.exports = __webpack_public_path__ + "img/logo.1a7ac05c.png";